import { AuthenticatedUser } from '@shared/Authentication';
import { ReportableUser } from './reportable-user';
import { ErrorMapping } from './error-mapping';
import { option } from 'fp-ts';

type Args = {
  error: any;
  loggedInUser?: AuthenticatedUser;
};

export class ReportableError {
  constructor(public readonly cause: string, public readonly loggedInUser?: ReportableUser) {}

  static of = (args: Args): ReportableError => {
    const mappedError = ErrorMapping.from(args.error);
    const mappedUser = option.toUndefined(ReportableUser.from(args.loggedInUser));

    return new ReportableError(mappedError, mappedUser);
  };
}
